import { styled } from '@mui/system';
import { Box, Button, Typography } from '@mui/material';

export const MetricCardContainer = styled(Button)(({ theme, active }) => ({
  background: active ? theme.palette.background.selected : theme.palette.primary.secondary,
  color: active ? theme.colors.white : theme.colors.gray,
  borderRadius: '9px',
  padding: theme.spacing(1),
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyItems: 'flex-start',
  width: '100%',
  gap: '4px',
}));

export const ValueContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(1),
}));

export const MetricValue = styled(Typography)(({ theme }) => ({
  ...theme.typography.title5,
  color: theme.colors.white,
}));

export const MetricLabel = styled(Typography)(({ theme, type }) => ({
  ...theme.typography.bodyRegular,
  color: type === 'ALL' ? theme.colors.white : theme.colors.gray,
}));
